import { DrEntity } from './dr-entity';
import { DrObject, DrObjectType } from './dr-object';

export enum TemplateType {
    ALIAS_LISTS = 'ALIAS_LISTS',
    ANALYTICAL_SETTINGS = 'ANALYTICAL_SETTINGS',
    BILLING_REPORT_SETTINGS = 'BILLING_REPORT_SETTINGS',
    CODING_SETTINGS = 'CODING_SETTINGS',
    CUSTOM_FIELDS = 'CUSTOM_FIELDS',
    DOCUMENT_METADATA = 'DOCUMENT_METADATA',
    DOMAIN_LISTS = 'DOMAIN_LISTS',
    DUPE_SURVIVORSHIP = 'DUPE_SURVIVORSHIP',
    EMAIL_SIGNATURE = 'EMAIL_SIGNATURE',
    EXPORT_FIELDS = 'EXPORT_FIELDS',
    EXPORT_SETTINGS = 'EXPORT_SETTINGS',
    INDEX_SETTINGS = 'INDEX_SETTINGS',
    LOADFILE_SETTINGS = 'LOADFILE_SETTINGS',
    REPORT_SETTINGS = 'REPORT_SETTINGS',
    SEARCH_FIELDS = 'SEARCH_FIELDS',
    SEARCH_SETTINGS = 'SEARCH_SETTINGS',
    TAG = 'TAG',
    USER_EXP = 'USER_EXP',
    META_TEMPLATE_PROFILE = 'META_TEMPLATE_PROFILE',
    WORKFLOWS = 'WORKFLOWS'    

}

export class TemplateViewModel extends DrObject {

    model: Partial<Template>;

    constructor(value: Partial<Template>) {
        super(DrObjectType.TEMPLATE);
        if (value) {
            this.model = value;
            this.templateType = value.templateType;
        }
    }
}

export class Template extends DrEntity {
    name: string;
    description: string;
    defaultTemplate: boolean;
    orgId: string;
    templateType: TemplateType;
    createdBy: string;
    scope = 'ORG_LEVEL';

    constructor(value?: Partial<Template>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }

    }
}
